import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import { ActualizarCatgProgramatica } from './modalActualizarCatgProgramarica';
import { Toasts } from '../toasts';

const TablaCatgProgramaticas = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  let municipios = [];

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CATEGORIA PROGRAMATICA', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [categoria, setCategoria] = useState();
  const [unidad, setUnidad] = useState([]);
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
  const permiso = '1111'
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: '',
    titulo: ''
  })
  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        if (target.value === "") {
          return items;
        } else {
          const lowerCaseTarget = target.value.toLowerCase();

          // Filtra por numdoc primero
          let filteredItems = items.filter(x => x.categoriaprogramatica.includes(target.value));

          // Si no hay coincidencias en numdoc, busca en los otros campos
          if (filteredItems.length === 0) {
            filteredItems = items.filter(x =>


              (x.descripcion !== '' && x.descripcion.toLowerCase().includes(lowerCaseTarget)) ||
              (x.idcategoriaprogramatica !== '' && x.idcategoriaprogramatica.toLowerCase().includes(lowerCaseTarget))

            );
          }

          return filteredItems;
        }
      }
    })

  }

  const SeleccionarRegistros = () => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/administracion/categoriaprogramatica?idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        setRecords(response.data);
        txtBuscador.current.focus()
      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SelectCategoriaProgramatica = (id, ope) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "categoriaprogramatica";
    let nomid = "idcategoriaprogramatica";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {
        console.log(response.data)

        if (response.data.idcategoriaprogramatica > 0) {
          setCategoria(response.data);
          if (response.data.idcoordinacion > 0) {
            SelectUnidadEjecutora(response.data, ope);
          } else {
            setUnidad([]);
            ConsultaUnidadxCuenta(response.data, ope);
          }
          
        } else {
          /*setCategoria()
          SelectUnidadEjecutora(response.data, ope);*/
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Error, La categoria no exite', icono: 'informacion' });
        }
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }

  const SelectUnidadEjecutora = (data, ope) => {

    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${data.idcoordinacion}`;

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then((response) => {

      if (response.status == 200) {

        if (response.data.idcoordinacion > 0) {
          setUnidad(response.data);
          ConsultaUnidadxCuenta(data);
        } else {
          setUnidad([]);
          ConsultaUnidadxCuenta(data);
        }
      }


    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })

  }

  const ConsultaUnidadxCuenta = (data, ope) => {

    let endpoint = `${op.conexion}/api/presupuesto/consultaxcuenta?id=${data.idcategoriaprogramatica}`;
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then((response) => {

      if (response.status == 200) {

        if (operacion === 2) {

          if (response.data.idcuenta > 0) {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Error, La categoria no se puede editar porque ya fue utilizada en cuentas presupuestaria!', icono: 'error' });

          } else {
            setMostrar2(true);
          }
        } else {
          setMostrar2(true);
        }


        setActivate(false);
      }


    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })

  }

  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarActuProgramatica = (op, id, per) => (e) => {
    setOperacion(op);
    if (per.toString() === '1') {
       if (op !== 1) {
        SelectCategoriaProgramatica(id, op);
      } else {
        setMostrar2(true)
      } 
    } else {
      setToast({
        mostrar: true,
        mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
        titulo: 'Alerta.'
      })
    }
  }


  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  }

  const cerrar = (e) => {
    e.preventDefault()
    props.menu()
  }

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false
    })
  }

  return (
    <section className='modal-azulGradiant mx-auto col-9'>

      <header className='header-azulGradiant'>
        <h3 >
          Categorias Programaticas
        </h3>
        <a type='button' onClick={cerrar} className='text-light '><i className="fas fa-times mx-2"></i><span className='fw-bold'>Salir</span></a>

      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input  col-3 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
        <button  onClick={gestionarActuProgramatica(1, '', permiso.toString().substring(1, 2))}  style={{ marginBottom: "5px" }} className={permiso.toString().substring(1, 2) === '1' ? 'btn btn-sm btn-primary rounded-pill' : 'btn btn-sm btn-secondary rounded-pill'}><i className="fas fa-plus"></i> </button>

      </div>

      <div className="col-md-12 m-0" >
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '100px' }}>{item.categoriaprogramatica}</td>
                  <td className='align-middle' style={{ textAlign: "left", alignItems: 'center', width: '300px' }}>{item.descripcion}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{item.idcategoriaprogramatica}</td>
                  <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>
                    <button onClick={gestionarActuProgramatica(4, item.idcategoriaprogramatica, permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'} ><i className="fas fa-eye"></i> </button>
                    <button onClick={gestionarActuProgramatica(2, item.idcategoriaprogramatica, permiso.toString().substring(2, 3))} className={permiso.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-edit"></i> </button>
                    <button onClick={gestionarActuProgramatica(3, item.idcategoriaprogramatica, permiso.toString().substring(3, 4))} className={permiso.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-trash"></i> </button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ActualizarCatgProgramatica
        show={mostrar2}
        operacion={operacion}
        categoria={categoria}
        unidad={unidad}
        onHideCancelar={handleCancelar}
         onHideRenderizar={SeleccionarRegistros} 
      />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaCatgProgramaticas;